// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"scrollbar_2zWm","page-container":"page-container_18xw","page-content":"page-content_1D67"};